<script lang="ts">
	export { classes as class };
	let classes = 'w-6 h-6';
</script>

<svg
	class={classes}
	width="24"
	height="24"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M5.37 3.48C7.2 3.23 9.6 3 12 3c2.4 0 4.8.23 6.63.48A2.77 2.77 0 0 1 21 6.28v7.12a2 2 0 0 1-1.72 1.98l-2.65.38c-1.4.2-2.68.99-3.45 2.2A66 66 0 0 0 12 19.93a66 66 0 0 0-1.18-1.95 4.87 4.87 0 0 0-3.45-2.21l-2.65-.38A2 2 0 0 1 3 13.4V6.28c0-1.44 1-2.62 2.37-2.8ZM12 1c-2.51 0-5 .25-6.9.5A4.77 4.77 0 0 0 1 6.27v7.12a4 4 0 0 0 3.43 3.96l2.66.38c.85.12 1.59.6 2.03 1.3a44.6 44.6 0 0 1 1.99 3.4 1 1 0 0 0 1.78 0 44.6 44.6 0 0 1 1.99-3.4 2.87 2.87 0 0 1 2.03-1.3l2.66-.38A4 4 0 0 0 23 13.4V6.28a4.77 4.77 0 0 0-4.1-4.79C17 1.25 14.5 1 12 1Zm-1 5a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0V6Zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
		fill="currentColor"
	/>
</svg>
